import { alpha } from '@mui/material/styles'

export const NAV_DISCREET_DARKEN_PERCENTAGE = 0.075
export const NAV_EVIDENT_DARKEN_PERCENTAGE = 0.15
export const NAV_DISCREET_LIGHTEN_PERCENTAGE = 0.075
export const NAV_EVIDENT_LIGHTEN_PERCENTAGE = 0.15

const withAlphas = (color) => ({
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5)
})

export const neutralLight = {
    50: '#F8F9FA',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D2D6DB',
    400: '#9DA4AE',
    500: '#6C737F',
    600: '#4D5761',
    700: '#2F3746',
    800: '#1C2536',
    900: '#111927'
}

export const neutralDark = {
    50: '#111927',
    100: '#1C2536',
    200: '#2F3746',
    300: '#4D5761',
    400: '#6C737F',
    500: '#9DA4AE',
    600: '#D2D6DB',
    700: '#E5E7EB',
    800: '#F3F4F6',
    900: '#F8F9FA'
}

export const blue = withAlphas({
    lightest: '#F5F8FF',
    light: '#EBEFFF',
    main: '#2970FF',
    dark: '#004EEB',
    darkest: '#00359E',
    contrastText: '#FFFFFF'
})

export const green = withAlphas({
    lightest: '#F6FEF9',
    light: '#EDFCF2',
    main: '#16B364',
    dark: '#087443',
    darkest: '#084C2E',
    contrastText: '#FFFFFF'
})

export const indigo = withAlphas({
    lightest: '#EEF2FF',
    light: '#E0E7FF',
    main: '#4F46E5',
    dark: '#4338CA',
    darkest: '#312E81',
    contrastText: '#FFFFFF'
})

export const orange = withAlphas({
    lightest: '#FFF7ED',
    light: '#FFEDD5',
    main: '#F97316',
    dark: '#C2410C',
    darkest: '#9A3412',
    contrastText: '#FFFFFF'
})

export const pink = withAlphas({
    lightest: '#F9F5FF',
    light: '#F4EBFF',
    main: '#af006d',
    dark: '#92035d',
    darkest: '#800651',
    contrastText: '#FFFFFF'
})

export const purple = withAlphas({
    lightest: '#F9F5FF',
    light: '#F4EBFF',
    main: '#9E77ED',
    dark: '#6941C6',
    darkest: '#42307D',
    contrastText: '#FFFFFF'
})

export const red = withAlphas({
    lightest: '#F9F5FF',
    light: '#f2dbdb',
    main: '#d22733',
    dark: '#98091d',
    darkest: '#540202',
    contrastText: '#FFFFFF'
})

export const teal = withAlphas({
    lightest: '#F0FDFA',
    light: '#CCFBF1',
    main: '#0F766E',
    dark: '#115E59',
    darkest: '#134E4A',
    contrastText: '#FFFFFF'
})

// The platform brands' own colours (backend org/branding.py PLATFORM_BRANDS), offered as
// accents and used as the default on their own domains (see resolveColorPreset).
export const joulelingo = withAlphas({
    lightest: '#EFFAF7',
    light: '#D2F0E8',
    main: '#0F7B6C',
    dark: '#0B5E53',
    darkest: '#08443C',
    contrastText: '#FFFFFF'
})

export const kilosight = withAlphas({
    lightest: '#F2F4FD',
    light: '#DDE2F8',
    main: '#3346B8',
    dark: '#26358C',
    darkest: '#1B2665',
    contrastText: '#FFFFFF'
})

export const accentColorOptions = [
    { label: 'Green', value: 'green', color: green.main },
    { label: 'Blue', value: 'blue', color: blue.main },
    { label: 'Indigo', value: 'indigo', color: indigo.main },
    { label: 'Orange', value: 'orange', color: orange.main },
    { label: 'Pink', value: 'pink', color: pink.main },
    { label: 'Purple', value: 'purple', color: purple.main },
    { label: 'Red', value: 'red', color: red.main },
    { label: 'Teal', value: 'teal', color: teal.main },
    { label: 'Joulelingo green', value: 'joulelingo', color: joulelingo.main },
    { label: 'Kilosight blue', value: 'kilosight', color: kilosight.main }
]

export const accentColorValues = accentColorOptions.map(({ value }) => value)

export const success = withAlphas({
    lightest: '#F0FDF9',
    light: '#3FC79A',
    main: '#10B981',
    dark: '#0B815A',
    darkest: '#134E48',
    contrastText: '#FFFFFF'
})

export const info = withAlphas({
    lightest: '#ECFDFF',
    light: '#CFF9FE',
    main: '#06AED4',
    dark: '#0E7090',
    darkest: '#164C63',
    contrastText: '#FFFFFF'
})

export const warning = withAlphas({
    lightest: '#FFFAEB',
    light: '#FEF0C7',
    main: '#F79009',
    dark: '#B54708',
    darkest: '#7A2E0E',
    contrastText: '#FFFFFF'
})

export const error = withAlphas({
    lightest: '#FEF3F2',
    light: '#FEE4E2',
    main: '#F04438',
    dark: '#B42318',
    darkest: '#7A271A',
    contrastText: '#FFFFFF'
})
